import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';

export class TranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    public prefix: string = '/assets/i18n/',
    public suffix: string = '.json',
  ) {}

  public getTranslation(lang: string): any {
    // L'URL des fichiers de traduction ne contient pas de hash (contrairement aux bundles JS) : on force le
    // navigateur à revalider auprès du serveur à chaque chargement (304 si inchangé), sinon le cache HTTP
    // peut servir un ancien fichier après un déploiement et afficher les clés à la place des libellés.
    // Complète la règle Cache-Control côté serveur (src/.htaccess) sans dépendre de la config Apache.
    return this.http.get(`${this.prefix}${lang}${this.suffix}`, {
      headers: { 'Cache-Control': 'no-cache' },
    });
  }
}

export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
